const Marquee = () => {
  const items = ["Plan", "Design", "Procure", "Install", "Commission", "Comply", "Maintain"];
  const Row = ({ hidden = false }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="px-6 font-heading text-2xl md:text-4xl font-semibold tracking-tight text-white/90 md:px-10">
            {item}
          </span>
          <svg viewBox="0 0 44 20" className="h-5 w-11 shrink-0 text-accent" fill="none" aria-hidden="true">
            <path d="M2 10h10l3-6 5 12 3-6h19" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      ))}
    </div>
  );
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-brand-900 py-6 md:py-8" data-testid="lifecycle-marquee">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
};

export default Marquee;
